import {Tr, TrSpace} from "@/i18n/i18n";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {LevelsInfo} from "@/store/creature/types";
import CreaturePanel from "@/scenes.ui/creature-panel";
import {Creature} from "@/store/level/types";
import BBCodeText from "phaser3-rex-plugins/plugins/bbcodetext";
import {ListTextPanel} from "@/scenes.ui/list-text-panel";
import {PriceButtonPanel} from "@/scenes.ui/price-button-panel";
import {Settings} from "@/constants/settings";
import Container = Phaser.GameObjects.Container;
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import PlayerStore from "@/store/player";
import {CardType} from "@/store/card/types";

export class ClassLevelPanel extends Phaser.GameObjects.Container {

    private static readonly INNER_BAR_WIDTH: number = 294;

    private mainContainer!: Container;
    private completeCallback!: () => unknown;

    constructor(scene: Phaser.Scene, creature: Creature, li: LevelsInfo, completeCallback: () => unknown) {
        super(scene);
        this.completeCallback = completeCallback;

        this.init(scene, creature, li);
    }

    public init(scene: Phaser.Scene, creature: Creature, li: LevelsInfo) {

        if (this.mainContainer) {
            this.mainContainer.setVisible(false);
            this.mainContainer.destroy();
        }
        this.mainContainer = new Container(scene);

        this.scene = scene;
        this.width = CU.CANVAS_WIDTH;

        const back = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, 1500 * CU.S);

        this.mainContainer.add(back);

        let clanTaskText = TextUtils.addTextAdvanced(scene, creature.name.toUpperCase() + ', ' + Tr('rang') + ': ' + li.level, 300, 30,
            '#d7d7d7', 12, 'normal', 480, 'center', 2, Fonts.ARIAL_MT);

        let sep = SpriteUtils.addSprite(this.scene, 300, clanTaskText.y / CU.S + 25, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.9, 0.6);

        let yy = 0;

        if (li.level < li.levels.length) {
            yy = sep.y / CU.S + 30
            if (li.level === 1 && li.doneCount < 1000) {
                let helpClanText = TextUtils.addTextAdvanced(scene, Tr('rang.1'), 300, yy,
                    '#ffcb5c', 14, 'normal', 500, 'center', 2, Fonts.ARIAL_MT);
                yy = helpClanText.y / CU.S + 40;
                this.mainContainer.add(helpClanText);
            }

            let gainText = TextUtils.addTextAdvanced(scene, Tr('dlja') + (li.level + 1) + '-' + Tr('go.level') + ':', 300, yy,
                '#979797', 12, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);

            yy = gainText.y / CU.S + 25;
            let itemsText = TextUtils.addTextAdvanced(scene, String(li.requiredCount) + Tr('dobivaniy'), 300, yy,
                '#ffd747', 14, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);

            yy = itemsText.y / CU.S;
            let light = SpriteUtils.addSprite(this.scene, 300, yy, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT, 4, 0.35);

            yy = light.y / CU.S + 100;

            this.mainContainer.add([light, gainText, itemsText]);
        } else {
            yy = sep.y / CU.S + 100;
        }

        let creaturePanel: CreaturePanel = new CreaturePanel(scene, 300, yy, creature, () => undefined, true);
        creaturePanel.setHealthVisible();

        if (li.level < li.levels.length) {
            let outerBar = SpriteUtils.addImage(this.scene, 150, creaturePanel.y / CU.S + 85, Keys.ATLAS_UI, Keys.UI_TASK_PROGRESS_BAR_OUTER)
                .setOrigin(0, 0);

            let innerBar = SpriteUtils.addImage(this.scene, outerBar.x  / CU.S  + 3, outerBar.y / CU.S + 4, Keys.ATLAS_UI, Keys.UI_TASK_PROGRESS_BAR_INNER)
                .setOrigin(0, 0);
            SpriteUtils.setDispSize(innerBar, ClassLevelPanel.INNER_BAR_WIDTH * (li.doneCount / li.requiredCount) * CU.S, 22 * CU.S);

            let completedText = TextUtils.addTextAdvanced(scene, Tr('vipolneno') + li.doneCount + '/' + li.requiredCount, 300, innerBar.y / CU.S + 40,
                '#d7d7d7', 12, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);

            this.mainContainer.add([innerBar, outerBar, completedText]);
            yy = completedText.y / CU.S + 25
        } else {
            yy = creaturePanel.y / CU.S + 100;
        }

        let sep2 = SpriteUtils.addSprite(this.scene, 300, yy, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.9, 0.6);

        let contentText = new BBCodeText(scene, 300 * CU.S, sep2.y + 30 * CU.S, '[size=16][color=#F6F6F6]' + Tr('rang.2') + '\n' +
            Tr('takim.obrazom.za.boy.mozhno.poluchit') +
            '[color=#C9FFA7]' + Tr('rang.3') + '[/color]\n\n' +
            '[color=#d7d7d7]' + Tr('rang.4') + '[/color][/size]', {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '14pt',
            align: 'center',
            wrap: {
                mode: 1,
                width: 550
            }
        }).setScale(CU.S, CU.S).setOrigin(0.5, 0);

        let sep3 = SpriteUtils.addSprite(this.scene, 300, contentText.getBottomCenter().y / CU.S + 25, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.9, 0.6);

        yy = sep3.y / CU.S + 25;
        let levNum = 1;
        for (let i of li.levels) {
            let curr = (levNum === li.level) ? Tr('tekuschiy') : '';
            let levelText = TextUtils.addTextAdvanced(scene, TrSpace('rang') + String(levNum) + curr, 300, yy,
                (levNum === li.level) ? '#fff0a6' : '#ffd747', 14, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);

            let sep4 = SpriteUtils.addSprite(this.scene, 300, levelText.y / CU.S + 20, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.3, 0.3);

            let levelDescText = new BBCodeText(scene, CU.CANVAS_WIDTH / 2, sep4.y + 20, i.description, {
                fontFamily: Fonts.MYRIADPRO_REGULAR,
                fontSize: '14pt',
                align: 'center',
                wrap: {
                    mode: 1,
                    width: 550
                }
            }).setScale(CU.S, CU.S).setOrigin(0.5, 0);

            let sep5 = SpriteUtils.addSprite(this.scene, 300, levelDescText.getBottomCenter().y / CU.S + 20, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.9, 0.6);
            this.mainContainer.add([levelText, levelDescText, sep4, sep5]);
            yy = sep5.y / CU.S + 25;
            ++levNum;
        }

        if (li.level < li.levels.length) {
            const nsRequired = li.nsRequired ?? 0;
            const arkRequired = li.arkRequired ?? 0;
            const notEnoughNsOrArk = nsRequired > 0 || arkRequired > 0;
            const isEagleCardActive = PlayerStore.GET_CARDS_STATE()!.activeCard === CardType.EAGLE;
            const completePrice = isEagleCardActive ? 0 : li.completePrice;

            let textMessage = '';
            let textHeight = 0;

            if (notEnoughNsOrArk) {
                if (nsRequired > 0 && arkRequired > 0) {
                    textMessage =  Tr('need.ns.count').replace('{count}', String(nsRequired)) + '\n' + Tr('need.ark');
                } else if (nsRequired > 0) {
                    textMessage = Tr(nsRequired === 1 ? 'need.ns' : 'need.ns.count').replace('{count}', String(nsRequired));
                } else if (arkRequired > 0) {
                    textMessage = Tr('need.ark');
                }
                textHeight = 150;
            } else {
                textMessage = Tr('ne.zhdat.i.poluchit') + (li.level + 1) + Tr('th.rang.now');
            }

            const textPanel: ListTextPanel = new ListTextPanel(scene!, textMessage, textHeight);
            textPanel.x = CU.CANVAS_WIDTH / 2;
            textPanel.y = yy * CU.S + 20;

            if (!notEnoughNsOrArk) {
                const completeButton: PriceButtonPanel = new PriceButtonPanel(scene!, completePrice, Tr('poluchit.seychas'), () => {
                    this.completeCallback();
                });
                completeButton.y = textPanel.y + 10;
                this.mainContainer.add([textPanel, completeButton]);
                this.height = completeButton.y / CU.S + 200;
            } else {
                this.mainContainer.add(textPanel);
                this.height = textPanel.y / CU.S + 200;
            }
        } else {
            this.height = yy / CU.S + 20;
        }

        this.mainContainer.add([clanTaskText, sep, creaturePanel, sep2, sep3, contentText]);

        this.add(this.mainContainer);
    }
}